import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

export const env = createEnv({
  server: {
    DATABASE_HOST: z.string(),
    DATABASE_USERNAME: z.string(),
    DATABASE_PASSWORD: z.string(),
    DATABASE_NAME: z.string(),
    CLERK_SECRET_KEY: z.string(),
    CLERK_WEBHOOK_SECRET: z.string(),
    STRIPE_SECRET_KEY: z.string(),
    STRIPE_WEBHOOK_SECRET: z.string(),
    STRIPE_LITE_PRICE_ID: z.string(),
    STRIPE_LITE_COUPON_ID: z.string(),
    STRIPE_PRO_PRICE_ID: z.string(),
    STRIPE_PRO_COUPON_ID: z.string(),
    STRIPE_30_HOURS_PRICE_ID: z.string(),
    TRIGGER_SECRET_KEY: z.string(),
    TRIGGER_WEBHOOK_SECRET: z.string(),
    SCRAPYBARA_API_KEY: z.string(),
    SCRAPYBARA_API_URL: z.string(),
    ANTHROPIC_API_KEY: z.string(),
    ANTHROPIC_LOW_API_KEY: z.string(),
    GOOGLE_VERTEX_PROJECT: z.string(),
    GOOGLE_VERTEX_LOCATION: z.string(),
    GOOGLE_CLIENT_EMAIL: z.string(),
    GOOGLE_PRIVATE_KEY: z.string(),
    GOOGLE_CLIENT_ID: z.string(),
    GOOGLE_CLIENT_SECRET: z.string(),
    EXA_API_KEY: z.string(),
    BRAVE_API_KEY: z.string(),
    AWS_REGION: z.string().default("us-east-1"),
    AWS_ACCESS_KEY_ID: z.string(),
    AWS_SECRET_ACCESS_KEY: z.string(),
    AWS_S3_BUCKET: z.string(),
    AWS_S3_BASE_ROLE_ARN: z.string(),
    REDIS_URL: z.string(),
    CLOUDFRONT_DOMAIN: z.string().optional(),
    FAL_API_KEY: z.string(),
    OPENAI_API_KEY: z.string(),
    LANGFUSE_SECRET_KEY: z.string(),
    LANGFUSE_PUBLIC_KEY: z.string(),
    LANGFUSE_BASE_URL: z.string(),
    FREESTYLE_API_KEY: z.string(),
    DEV_PASSWORD: z.string().optional(),
    GITHUB_CLIENT_ID: z.string(),
    GITHUB_CLIENT_SECRET: z.string(),
    INSTAGRAM_APP_ID: z.string(),
    INSTAGRAM_APP_SECRET: z.string(),
    SERPER_API_KEY: z.string(),
    CF_ACCOUNT_ID: z.string(),
    CF_API_TOKEN: z.string(),
    CF_KV_NAMESPACE_ID: z.string(),
    CF_DISPATCH_NAMESPACE: z.string(),
  },
  client: {
    NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY: z.string(),
    NEXT_PUBLIC_POSTHOG_KEY: z.string(),
  },
  experimental__runtimeEnv: {
    NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY:
      process.env.NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY,
    NEXT_PUBLIC_POSTHOG_KEY: process.env.NEXT_PUBLIC_POSTHOG_KEY,
  },
});
